export interface StatItem {
  label: string;
  value: string;
  icon: string;
}

export const stats: StatItem[] = [
  { label: '注册用户', value: '180万+', icon: 'ri-user-line' },
  { label: '主题帖子', value: '650万+', icon: 'ri-chat-3-line' },
  { label: '每日活跃', value: '25万+', icon: 'ri-fire-line' },
  { label: '优质版块', value: '8大类', icon: 'ri-stack-line' },
];

export interface Testimonial {
  name: string;
  role: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: '代码行者',
    role: '技术交流版主',
    content: '在海角论坛做版主三年了，见证了这个平台从一个小社区成长为百万用户的大平台。这里的氛围一直很好，大家互相帮助，共同进步。',
    rating: 5,
  },
  {
    name: '北漂日记',
    role: '资深用户',
    content: '海角论坛是我每天必逛的网站。在这里结识了很多志同道合的朋友，也学到了很多有用的知识。尤其是生活杂谈版块，让我在异乡找到了归属感。',
    rating: 5,
  },
  {
    name: '追梦人小李',
    role: '学习版活跃用户',
    content: '备考公务员那段时间，海角论坛的学习版给了我很多帮助。大家分享的资料和经验非常实用，最终我也成功上岸了。非常感谢这个平台！',
    rating: 5,
  },
  {
    name: '影评人阿明',
    role: '影视娱乐达人',
    content: '作为一个影评人，海角论坛的影视娱乐版是我见过讨论氛围最好的中文社区。大家畅所欲言，理性讨论，这种氛围太难得了。',
    rating: 5,
  },
  {
    name: '快门侠',
    role: '摄影版活跃用户',
    content: '在海角论坛的摄影版发帖三年了，每次都能收到很多诚恳的评价和建议。正是因为大家的反馈，我的摄影水平提升了很多。',
    rating: 5,
  },
  {
    name: '游戏老司机',
    role: '游戏电竞版主',
    content: '海角论坛的游戏版真的是藏龙卧虎，各种大神都在这里分享攻略和心得。作为版主，维护这个高质量的讨论环境让我很有成就感。',
    rating: 5,
  },
];